<template>
  <v-container grid-list-xs>
    <v-layout row wrap pt-2>
      <v-flex xs12 class="text-xs-center my-3 title text-uppercase">
        <span class="font-weight-light">WA</span>
        <span>Settings</span>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap pa-4>
            <v-flex xs12 my-2 v-for="(s, i) in settings" :key="i+'-setting'">
              <v-card>
                <v-layout pa-3 row wrap align-center>
                  <v-flex xs2 px-1>
                    <v-checkbox label="Official API?" :disabled="loading" @change="updateSetting(s)" v-model="s.official" value="true"></v-checkbox>
                  </v-flex>
                  <v-flex xs4 px-1>
                    <div style="font-size:11px;font-weight:700;">Company Code (all Caps)</div>
                    <v-select
                      label="Company Code"
                      v-model="s.cc"
                      solo
                      :items="companycodes"
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <div style="font-size:11px;font-weight:700;">Phone number</div>
                    <v-text-field
                      label="Number"
                      v-model="s.number"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <div style="font-size:11px;font-weight:700;">Instance URL</div>
                    <v-text-field
                      label="Instance URL"
                      v-model="s.instance"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <div style="font-size:11px;font-weight:700;">Webhook</div>
                    <v-text-field
                      label="Webhook"
                      v-model="s.webhook"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1 v-if="s.official">
                    <div style="font-size:11px;font-weight:700;">ADMIN</div>
                    <v-text-field
                      label="ADMIN"
                      v-model="s.admin"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1 v-if="s.official">
                    <div style="font-size:11px;font-weight:700;">PASSWORD</div>
                    <v-text-field
                      label="PASSWORD"
                      v-model="s.password"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1 v-if="!s.official">
                    <div style="font-size:11px;font-weight:700;" v-if="!s.official">Instance Secret</div>
                    <v-text-field
                      label="Instance Secret"
                      v-model="s.secret"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1 v-if="!s.official">
                    <div style="font-size:11px;font-weight:700;" v-if="!s.official">Instance Token</div>
                    <v-text-field
                      label="Instance Token"
                      v-model="s.token"
                      solo
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <div style="font-size:11px;font-weight:700;">Instance ID</div>
                    <v-text-field
                      label="Instance ID"
                      v-model="s.id"
                      solo
                      hide-details
                      @change="updateSetting(s)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 px-1>
                    <div style="font-size:11px;font-weight:700;">Instance State</div>
                    <v-select
                      label="Instance State"
                      v-model="s.state"
                      :items="['old', 'new']"
                      solo
                      :disabled="loading"
                      hide-details
                      @change="updateSetting(s)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="s.official">
                    <v-btn color="primary" @click="registerNumberDialog = true" outline :loading="loading" :disabled="loading">register</v-btn>
                    <v-layout row justify-center>
                      <v-dialog v-model="registerNumberDialog" persistent max-width="450">
                        <v-card>
                          <v-card-title class="headline">Register Number</v-card-title>
                          <v-card-text>
                            <v-layout row wrap v-if="!codeverification">
                              <v-flex xs12>
                                <v-text-field
                                  label="Country Code"
                                  solo
                                  v-model.trim="nwa.cc"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  label="Number"
                                  solo
                                  v-model.trim="nwa.phone_number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  label="Pin"
                                  solo
                                  v-model.trim="nwa.pin"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  label="method"
                                  solo
                                  v-model.trim="nwa.method"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-textarea
                                  label="Cert"
                                  solo
                                  v-model.trim="nwa.cert"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="codeverification">
                              <v-flex xs12>
                                <v-text-field
                                  label="Code"
                                  solo
                                  v-model.trim="vnwa.code"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                          
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" flat @click.native="registerNumberDialog = false">cancel</v-btn>
                            <v-btn color="primary" v-if="!codeverification" flat @click.native="registerNumber(s)">Register</v-btn>
                            <v-btn color="primary" v-if="codeverification" flat @click.native="registerNumberVerification(s)">verify</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="s.official && false">
                    <v-btn color="primary" @click="healthCheck(s)" outline :loading="loading" :disabled="loading">check status</v-btn>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="s.official && false">
                    <v-btn color="primary" @click="autoSetup(s)" outline :loading="loading" :disabled="loading">autosetup</v-btn>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="!s.official && false">
                    <v-btn color="primary" @click="setupInstance(s)" outline :loading="loading" :disabled="loading">setup Instance</v-btn>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="!s.official && false">
                    <v-btn color="primary" @click="checkStatus(s)" outline :loading="loading" :disabled="loading">check status</v-btn>
                  </v-flex>
                  <v-flex xs2 px-1 v-if="!s.official && false">
                    <v-btn color="primary" @click="useHere(s)" outline :loading="loading" :disabled="loading">use WA here</v-btn>
                  </v-flex>
                </v-layout>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="loading" flat @click.native="genToken(s)">GEN TOKEN</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="startSession(s)">start session</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="statusSession(s)">status session</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="checkSessionStatus(s)">check status</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="qrSession(s)">QR session</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="closeSession(s)">close session</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="getChatsAndMessages(s)">get msgs</v-btn>
                  <v-btn color="primary" :loading="loading" flat @click.native="logoutSession(s)">logout session</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs1>
              <v-btn color="primary" @click="addNumber()" dark>add number</v-btn>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="storeSettings()" dark>store settings</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-dialog fullscreen v-model="qr" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Please Scan QR</v-card-title>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12>
                <img :src="qrCode">
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="primary" @click="statusSession(checkInstance)" dark>Logged In On Phone</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="qr = false">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    
  </v-container>
</template>

<script>
import axios from 'axios';
import { uuid } from '@/customFunction';
import { storageRef, firebase, db, auth } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {
  'Accept': 'application/json'
}

export default {
  data(){
    return {
      loading:false,
      settings:[],
      qr:null,
      qrCode:null,
      checkInstance:null,
      companycodes:[],
      registerNumberDialog:false,
      codeverification:false,
      nwa:{},
      vnwa:{},
    }
  },
  methods:{
    async loadSettings(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await db.ref(`settings/newwa/numbers`).once('value').then(x=>x.val())
        console.log(a)
        this.settings = a? Object.values(a).map((x, i)=>{return{...x,key:Object.keys(a)[i]}}).sort( (a, b)=> a.cc > b.cc ? -1 : 1 ) : []
        this.loading = false
        res(true)
      })
    },
    async updateSetting(s) {
      return new Promise(async (res, rej)=>{
        this.loading = true
        await db.ref(`settings/newwa/numbers/${s.key}`).update(s)
        this.$emit('snackbarNotification', `Autosaved`, 'success')
        this.loading = false
        res(true)
      })
    },
    async genToken(s) {
      return new Promise (async (res, rej)=>{
        if(!s.id){
          s.id = getRandomInt(11111, 999999)
        }
        this.loading = true
        var config = {
          method: 'post',
          url: `${s.instance}/ashyaat${s.id}/${s.secret}/generate-token`,
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.token) {
          s.token = r.token
          await this.updateSetting(s)
          await this.loadSettings()
          this.loading = false
        }
        res(r)
      })
    },
    async startSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var data = JSON.stringify({
          "webhook": s.webhook,
          "waitQrCode": true
        });
        var config = {
          method: 'post',
          url: `${s.instance}/ashyaat${s.id}/start-session`,
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': 'Bearer ' + s.token
          },
          data
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.qrcode && r.status != "CONNECTED") {
          this.loading = false
          this.qr = true
          this.qrCode = !r.qrcode.includes('data:image') ? 'data:image/png;base64,' + r.qrcode : r.qrcode 
          this.checkInstance = s
        } else if(r.status == "CONNECTED") {
          this.loading = false
          this.$emit('snackbarNotification', `Authenticated`, 'success')
        } else {
          this.loading = false
          this.$emit('snackbarNotification', `Count to 20 and try again`, 'success')
        }
        res(r)
      })
    },
    async statusSession(s) {
      return new Promise (async (res, rej)=>{
        var config = {
          url: `${s.instance}/ashyaat${s.id}/status-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.qrcode) {
          this.loading = false
          this.qr = true
          this.qrCode = !r.qrcode.includes('data:image') ? 'data:image/png;base64,' + r.qrcode : r.qrcode 
          this.checkInstance = s
        } else if(r.status == "CONNECTED") {
          this.loading = false
          this.$emit('snackbarNotification', `Authenticated`, 'success')
        } else if(!r.qrcode && r.status == "CLOSED") {
          this.loading = false
          this.$emit('snackbarNotification', `Please click start first and wait for 20 seconds`, 'success')
        }
        res(r)
      })
    },
    async checkSessionStatus(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/ashyaat${s.id}/check-connection-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r) {
          this.loading = false
          this.$emit('snackbarNotification', `STATUS: ${r.status} | ${r.message}`, 'success')
        }
        res(r)
      })
    },
    async qrSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/ashyaat${s.id}/qrcode-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r) {
          this.loading = false
          this.qr = true
          this.qrCode = r
          this.checkInstance = s
        }
        res(r)
      })
    },
    async closeSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/ashyaat${s.id}/close-session`,
          method: 'post',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r.status) {
          this.$emit('snackbarNotification', `Browser Closed`, 'success')
          this.loading = false
        } else {
          this.$emit('snackbarNotification', `Failed closing`, 'success')
          this.loading = false
        }
        res(r)
      })
    },
    async logoutSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/ashyaat${s.id}/logout-session`,
          method: 'post',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r.status) {
          this.$emit('snackbarNotification', `WA logged out`, 'success')
          this.loading = false
        } else {
          this.$emit('snackbarNotification', `Failed WA log out`, 'success')
          this.loading = false
        }
        res(r)
      })
    },
    async getChatsAndMessageslogoutSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/ashyaat${s.id}/all-chats`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };

        let r = await axios(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        
        res(r)
      })
    },
    async registerNumber(s) {
      let d = {
        data:this.nwa,
        s
      }
      let a = await axios.post(`${api}/requestCodeOWA`, d, {headers}).then(x=>x.data)
      console.log(a)
      if(a.status) {
        this.codeverification = true
        this.registerNumberDialog = true
      }
    },
    async registerNumberVerification(s) {
      let d = {
        data:this.vnwa,
        s
      }
      let a = await axios.post(`${api}/verifySetupOWA`, d, {headers}).then(x=>x.data)
      console.log(a)
      if(a.status) {
        this.codeverification = false
        this.registerNumberDialog = false
        this.nwa = {}
        this.vnwa = {}
        this.$emit('snackbarNotification', `Verified`, 'success')
      }
    },
    async healthCheck(s){
      let a = await axios.post(`${api}/getWAHealth`, s, {headers}).then(x=>x.data)
      console.log(a)
    },
    async autoSetup(s) {
      let d = {
        s,
        data:{
          "text": "أهلا بكم في شركة اشياءات  نستقبلكم من السبت الى الخميس من الساعة ٩ صباحا و حتى ٦ مساءً بتوقيت الرياض"
        },
        data2:{
          "address": "AJMAN, UAE",
          "description": "Ashyaat.com",
          "email": "reply@ashyaat.com",
          "vertical": "Shopping and Retail",
          "websites": [
            "https://ashyaat.com"
          ]
        },
      }
      let a = await axios.post(`${api}/autoOWASetup`, d, {headers}).then(x=>x.data)
      console.log(a)
      if(a.status) {
        this.$emit('snackbarNotification', `Setup Done`, 'success')
      }
    },
    
    async setupNumber(s){
      let l = await this.LoginOfficialWA(s)
      var data = JSON.stringify({
        "address": "AJMAN, UAE",
        "description": "Ashyaat.com",
        "email": "reply@ashyaat.com",
        "vertical": "Shopping and Retail",
        "websites": [
          "https://ashyaat.com"
        ]
      });

      var config = {
        method: 'post',
        url: s.instance + '/v1/settings/business/profile',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer ' + l
        },
        data : data
      };

      await axios(config)
      this.setupNumberDs(s)
    },
    async setupNumberDs(s){
      let l = await this.LoginOfficialWA(s)
      var data = JSON.stringify({
        "text": "أهلا بكم في شركة اشياءات  نستقبلكم من السبت الى الخميس من الساعة ٩ صباحا و حتى ٦ مساءً بتوقيت الرياض"
      });

      var config = {
        method: 'patch',
        url: s.instance + '/v1/settings/profile/about',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer ' + l
        },
        data : data
      };

      await axios(config)
      this.setupHook(s)
    },
    async setupHook(s){
      let l = await this.LoginOfficialWA(s)
      var data = JSON.stringify({
        "webhooks": {
          "url": "<Webhook URL, https>"
        }
      });

      var config = {
        method: 'patch',
        url: s.instance + '/v1/settings/application',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer ' + l
        },
        data : data
      };
      await axios(config)
    },
    async getHealth(s) {
      let l = await this.LoginOfficialWA(s)
      var config = {
        method: 'get',
        url: '{{URL}}/v1/health',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer {{AdminAuthToken}}'
        }
      };

      axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
    },
    uid(){
      return randomString(10, '#Aa')
    },
    
    async storeSettings() {
      let s = {}
      for (let i = 0; i < this.settings.length; i++) {
        const set = this.settings[i];
        s[set.key] = set
      }
      await db.ref(`settings/newwa/numbers`).update(s)
      this.$emit('snackbarNotification', `Updated Settings`, 'success')
    },
    async setupInstance(s){
      let setting = {
        // "webhookUrl": "// WA API //",
        "ackNotificationsOn": "true",
        "chatUpdateOn": "false",
        "videoUploadOn": "true",
        "guaranteedHooks": "true",
        "ignoreOldMessages": "false",
        "instanceStatuses": "true",
        "webhookStatuses": "true",
        "statusNotificationsOn": "false"
      }
      let a = await axios.post(`${s.instance}/settings?token=${s.token}`, setting, {headers}).then(x=>x.data)
      console.log(a)
      this.$emit('snackbarNotification', `Updated Settings`, 'success')
    },
    async useHere(s){
      let setting = {
      }
      let a = await axios.post(`${s.instance}/takeover?token=${s.token}`, setting, {headers}).then(x=>x.data)
      console.log(a)
      this.$emit('snackbarNotification', `Whatsapp used here now`, 'success')
    },
    async getInstanceSettings(s){
      let a = await axios.get(`${s.instance}/settings?token=${s.token}`).then(x=>x.data)
      console.log('settings', a)
    },
    async checkStatus(s) {
      this.loading = true
      let a = await axios.get(`${s.instance}/status?token=${s.token}`).then(x=>x.data)
      console.log(a)
      if(a.qrCode) {
          this.qr = true
          this.qrCode = a.qrCode
          this.checkInstance = s
          this.$emit('snackbarNotification', `Please scan ${s.number} QR code`, 'error')
      } else if(a.accountStatus == 'authenticated') {
        this.$emit('snackbarNotification', `${a.accountStatus}`, 'success')
        this.qr = false
        this.qrCode = null
        this.checkInstance = null
      } else {
        this.$emit('snackbarNotification', `Please Click On Use WA Here`, 'success')
        this.qr = false
        this.qrCode = null
        this.checkInstance = null
      }
      this.loading = false

    },
    async addNumber(){
      let k = this.uid()
      await db.ref(`settings/newwa/numbers/${k}`).update({key:k})
      this.loadSettings()
    },
    async getCompanyCodes(){
      return new Promise(async(res, rej)=>{
        this.companycodes = await db.ref(`settings/dbfilters/companycodes`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
        res(true)
      }) 
		},
  },
  async created(){
    await this.getCompanyCodes()
    await this.loadSettings()
    function decideAssign(b){
      let n = b.filter(x=>x.state == 'new')
      let l = n.filter(x=>x.count < 301)
      let t = l.filter(x => (new Date().getTime() - x.timestamp) >= 2.4 * 60 * 60 * 1000)
      let s = t.sort((a, b) => a.timestamp - b.timestamp)
      if(s.length){
        return s[0]
      } else {
        let n = b.filter(x => x.state != 'new')
        let s = n.sort((a, b) => a.timestamp - b.timestamp)
        return s[0]
      }
    }
    let a = await db.ref('settings/newwa/numbers').once('value').then(x => x.val())
    if (a) {
      let bk = Object.keys(a)
      let b = Object.values(a).map((x, i) => {
          let t = x.timestamp ? x.timestamp : 0
          return {
            ...x,
            timestamp:t,
            key: bk[i]
          }
        })
        .filter(x => x.cc ? x.cc.toUpperCase().trim() == 'Ashyaat gulf'.toUpperCase().trim() : x.cc)
      // let c = b.length ? b[getRandomInt(0, b.length - 1)] : null
      // let d = b.sort((a, b)=> a.timestamp - b.timestamp)
      // let f = d[0] ? d[0] : null
      // c = f ? f : c
      let c = decideAssign(b)
      console.log(c)
    }
  }
}
</script>

<style>
</style>